<template>
  <div class="inquiry" style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>限时折扣</el-breadcrumb-item> -->
        <el-breadcrumb-item
        style="cursor: pointer"
        @click.native="breadcrumbClick(item.id, index, item)"
        v-for="(item, index) in breadcrumbList"
        :key="item.id"
        >{{ item.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="breadcrumbList.length == 1 ? true : false"
        >所有</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="title">询价信息</div>
    <div class="formData">
      <el-form ref="form" :model="formInline" label-width="130px" :rules="rules"> 
        <el-form-item label="项目名称">
          <div class="project">
            <el-input
              size="small"
              v-model="formInline.projectName"
              placeholder="项目名称"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="收货地址" prop="address">
          <el-input
            size="small"
            v-model="formInline.address"
            placeholder="请输入收货地址"
          ></el-input>
          <!-- <el-cascader
            size="small"
            v-model="formInline.address"
            :options="options"
            @change="handleChange"
          ></el-cascader> -->
        </el-form-item>
        <el-form-item label="公司名称">
          <div class="name">
            <el-input
              size="small"
              v-model="formInline.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </div>
        </el-form-item>
        <div class="user">
          <el-form-item label="联系人" prop="name">
            <el-input
              size="small"
              v-model="formInline.contact"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
              size="small"
              v-model="formInline.contactPhone"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="要求到货日期">
            <el-date-picker
              size="small"
              v-model="value1"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item> -->
        </div>
        <el-form-item label="其他说明">
          <div class="explain">
            <el-input
              v-model="formInline.remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            >
            </el-input>
          </div>
        </el-form-item>
        <div class="commoditList">
          <div class="shop">商品清单</div>
          <!-- <div class="import" @click="getImport">批量导入</div>
                    <div class="importPhoto">上传清单(照片,文档,表格)</div> -->
        </div>
        <br />
        <div class="tableAdd">
          <el-table align="center" :data="formInline.list">
            <!-- <el-table-column label="序号" width="90px">
              <template slot-scope="scope">
                {{ scope.row.id }}
              </template>
            </el-table-column> -->
            <el-table-column label="商品名称(助记码)" prop="skuName">
              <template slot-scope="scope">
                <el-select
                filterable
                  @change="(v) => onChange(v, scope.row)"
                  v-model="scope.row.skuName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in shopSelect"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="brandName" label="品牌">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.brandName"
                  placeholder="请输入内容"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="商品描述"
              width="260px"
              align="center"
              prop="remark"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.remark"
                  placeholder="请输入内容"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="单价"> </el-table-column>
            <el-table-column prop="number" label="数量">
              <template slot-scope="scope">
                <el-input
                :min="0"
                  v-model="scope.row.number"
                  type="number"
                  placeholder="请输入内容"
                ></el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="单位" width="90px">
              <template slot-scope="scope">
                <el-autocomplete
                  class="inline-input"
                  v-model="scope.row.company"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                >
                </el-autocomplete>
              </template>
            </el-table-column> -->
            <el-table-column label="小计" prop="count">
              <template slot-scope="scope">
                <span>{{ scope.row.price * scope.row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="要求到货时间" prop="arrivalTime">
              <template slot-scope="scope">
                <el-date-picker
                  size="small"
                  v-model="scope.row.arrivalTime"
                  type="datetime"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="280px"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <div class="operation">
                  <!-- <div>查看详情</div> -->
                  <div
                    v-if="scope.$index != 0"
                    @click="removeShop(scope.$index)"
                  >
                    删除
                  </div>
                  <div class="addShop" @click="addPurchase(scope.row, scope.$index)">加入采购单</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="continue">
          <div class="continueAdd" @click="addShop">+继续添加商品</div>
          <div class="continueJoin">
            <!-- <div class="matching">已匹配商品加入采购单</div> -->
            <div class="submit" @click="postAddShop">提交询价单</div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="上传附件" :visible.sync="dialogVisible" width="33%">
      <div class="upload">
        <div class="uploadFir">第一步:<span>下载Excel模板</span></div>
        <div class="uploadSec">
          第二步:<span>选择文件</span
          ><em>说明:通过下载模板，将信息款速导入，可以大量缩短报价时间哦~</em>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import {userFeedback,serviceGuarantee,shoppingCartlist,commoditylist,commodityDetails,getAttributelist,getSpecificationDetail,addShoppingCart,area_list,storerList,removeCollection,addCollection,goodsAdvice,addgoodsAdvice,commentList,replayComment,score} from "@/api/xunyou";
export default {
  data() {
    return {
      breadcrumbList: [{ id: 1, name: "首页", url: "/" },{ id: 0, name: "所有", url: "/limitDiscounts" }], //面包屑数组
      dialogVisible: false,
      restaurants: [],
      state1: "",
      input: "",
      number: 0,
      tableData: [],
      value1: "",

      radio: "1",

      value: [],
      options: [],

      shopSelect: [],
      shopObj: {},
      priceId:'',
      formInline: {
        list: [
          {
            arrivalTime: "",
            brandId: 0,
            brandName: "",
            count: 0,
            fileName: "",
            number: 0,
            price: 0,
            projectId: 0,
            projectName: "",
            projectType: 0,
            skuId: 0,
            skuName: "",
          },
        ],
      },
      updateData: {},
      rules:{
          name: [
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入联系方式', trigger: 'blur' },
          ],
      }
    };
  },
  computed: {
    getCount() {
      return (row) => {
        return row.count * row.number;
      };
    },
  },
  mounted() {
    this.restaurants = this.loadAll();
    this.options = this.$store.state.getprovince;
  },
  created() {
    this.priceId = this.$route.query.id
    this.getList()
    this.getShopSelect();
    const formData = JSON.parse(sessionStorage.getItem("priceEdit"));
    axios
      .get(
        `https://www.nays.com.cn/center/purchaser/inquiry/inquiry/details/list?inquiryId=${formData.id}`
      )
      .then((res) => {
        const data = res.data.data;
        const info = Object.assign({}, data.bxyInquiry, data.bxyInquiryUser);
        this.updateData = {
          inquiryUserDTO: info,
          submitInquiryDTO: {
            areaId: info.areaId,
            inquiryId: data.bxyInquiry.id,
            commodityList: data.inquiryShopList,
            userId: info.userId,
            userName: info.userName,
          },
        };
        this.formInline = {
          ...info,
          list: data.inquiryShopList,
        };
      });
  },
  methods: {
    // 面包屑点击事件
    breadcrumbClick(id, index, item) {
      if (id == 1) {
        // 说明是首页 文字
        this.$router.push("/");
      }
    
    },
    
    getList() {
      const userInfo = JSON.parse(localStorage.getItem("userdata"));
      axios
        .get(
          `https://www.nays.com.cn/center/purchaser/inquiry/inquiry/list?userId=${userInfo.userId}&pageNum=1&pageSize=10`
        )
        .then((res) => {
          const data = res.data;
          const list = data.data.rows.map((item) =>
            Object.assign({}, item.bxyInquiryUser, item.bxyInquiry)
          );
          let newArr = list.find(res=>this.priceId == res.id)
          this.formInline={
            projectName:newArr.projectName,
            address:newArr.address,
            contact:newArr.contact,
            contactPhone:newArr.contactPhone,
            remark:newArr.remark,
            list:[]
          }
          console.log(newArr,'rwrawraw')
        });
    },
    postAddShop() {
      const data = this.updateData;
      //   const userInfo = JSON.parse(localStorage.getItem("userdata"));
      const inquiryUserDTO = JSON.parse(JSON.stringify(this.formInline));
      Reflect.deleteProperty(inquiryUserDTO, "list");
      //   inquiryUserDTO.userId = userInfo.userId
      //   inquiryUserDTO.userName = userInfo.userName
      //   const submitInquiryDTO = {
      //       areaId: userInfo.areaid,
      //       commodityList: this.formInline.list,
      //       userId: userInfo.userId,
      //       userName: userInfo.userName
      //   }
      //   data.inquiryUserDTO = inquiryUserDTO
      //   data.submitInquiryDTO = submitInquiryDTO
      data.inquiryUserDTO = { ...data.inquiryUserDTO, ...inquiryUserDTO };
      data.submitInquiryDTO.commodityList = this.formInline.list;
      console.log(data);
      axios
        .post(
          "http://120.48.72.55:28080/purchaser/inquiry/update/inquiry/all",
          data
        )
        .then((res) => {});
    },
    addShop() {
      this.formInline.list.push({
        arrivalTime: "",
        brandId: 0,
        brandName: "",
        count: 0,
        fileName: "",
        number: 0,
        price: 0,
        projectId: 0,
        projectName: "",
        projectType: 0,
        skuId: 0,
        skuName: "",
      });
    },
    getShopSelect() {
      const userInfo = JSON.parse(localStorage.getItem("userdata"));
      axios({
        method: "post",
        url: "http://120.48.72.55:28080/custom/xunyou/commodity/api/recommend/pcCommoditylist",
        data: {
          userId: userInfo.userId,
          stype: 2,
        },
        transformRequest: [
          function (data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            ret = ret.substring(0, ret.lastIndexOf("&"));
            return ret;
          },
        ],
      }).then((res) => {
        this.shopSelect = res.data.rows;
        const obj = {};
        res.data.rows.forEach((item) => {
          obj[item.name] = item;
        });
        this.shopObj = obj;
      });
    },
    onChange(v, row) {
      console.log(v, row);
      const value = this.shopObj[v];
      console.log(this.shopObj);
      row.price = value.price;
      row.brandName = value.brandName;
      row.projectName - value.name
    },

    addPurchase(row, rowIndex) {
        const userInfo = JSON.parse(localStorage.getItem("userdata"));
      addShoppingCart({
        cid: row.id,
        uid: userInfo.userId,
        number: row.number,
        bxysid: 0,
      })
        .then((res) => {
            this.$message.success("添加成功");
            this.removeShop(rowIndex)
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("添加购物车失败，请稍后再试！");
        });
      //   getExcel().then((res) => {
      //     console.log(res.data.msg, "resssssssssssssss");
      // const blob = new Blob([res.data.msg], {
      //     type: "application/vnd.ms-excel"
      // });

      // const downloadElement = document.createElement("a");
      // const href = window.URL.createObjectURL(blob);
      // downloadElement.href = href;
      // downloadElement.download = "学生成绩.xls";
      // document.body.appendChild(downloadElement);
      // downloadElement.click();
      // document.body.removeChild(downloadElement);
      //   });
    },
    onSubmit() {
      console.log("submit!");
    },
    handleChange(value) {
      console.log(value);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      return [
        { value: "三全鲜食（北新泾店）", address: "长宁区新渔路144号" },
        {
          value: "Hot honey 首尔炸鸡（仙霞路）",
          address: "上海市长宁区淞虹路661号",
        },
        {
          value: "新旺角茶餐厅",
          address: "上海市普陀区真北路988号创邑金沙谷6号楼113",
        },
        { value: "泷千家(天山西路店)", address: "天山西路438号" },
        {
          value: "胖仙女纸杯蛋糕（上海凌空店）",
          address: "上海市长宁区金钟路968号1幢18号楼一层商铺18-101",
        },
        { value: "贡茶", address: "上海市长宁区金钟路633号" },
        {
          value: "豪大大香鸡排超级奶爸",
          address: "上海市嘉定区曹安公路曹安路1685号",
        },
        {
          value: "茶芝兰（奶茶，手抓饼）",
          address: "上海市普陀区同普路1435号",
        },
        { value: "十二泷町", address: "上海市北翟路1444弄81号B幢-107" },
        { value: "星移浓缩咖啡", address: "上海市嘉定区新郁路817号" },
        { value: "阿姨奶茶/豪大大", address: "嘉定区曹安路1611号" },
        { value: "新麦甜四季甜品炸鸡", address: "嘉定区曹安公路2383弄55号" },
        {
          value: "Monica摩托主题咖啡店",
          address: "嘉定区江桥镇曹安公路2409号1F，2383弄62号1F",
        },
        {
          value: "浮生若茶（凌空soho店）",
          address: "上海长宁区金钟路968号9号楼地下一层",
        },
        { value: "NONO JUICE  鲜榨果汁", address: "上海市长宁区天山西路119号" },
        { value: "CoCo都可(北新泾店）", address: "上海市长宁区仙霞西路" },
        {
          value: "快乐柠檬（神州智慧店）",
          address: "上海市长宁区天山西路567号1层R117号店铺",
        },
        {
          value: "Merci Paul cafe",
          address: "上海市普陀区光复西路丹巴路28弄6号楼819",
        },
        {
          value: "猫山王（西郊百联店）",
          address: "上海市长宁区仙霞西路88号第一层G05-F01-1-306",
        },
        {
          value: "南拳妈妈龙虾盖浇饭",
          address: "普陀区金沙江路1699号鑫乐惠美食广场A13",
        },
      ];
    },
    handleSelect(item) {
      console.log(item);
    },
    removeShop(val) {
      //   let newArr = {
      //     date: "",
      //     name: "",
      //     content: "",
      //     id: this.tableData[val].id,
      //     price: "",
      //     num: "",
      //     company: "",
      //     endTime: "",
      //     product: "",
      //     brand: "",
      //   };
      this.formInline.list.splice(val, 1);
      //   this.$set(this.tableData, val, newArr);
    },
    getImport() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style scoped lang="less">
.inquiry {
  max-width: 1200px;
  margin: 0 auto;

  .title {
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    padding: 10px 5px 0;
    font-size: 16px;
    border-bottom: 1px solid #d3d3d3;
  }

  .formData {
    margin-top: 10px;
  }
}

/deep/ .el-input__inner {
  background-color: #fff;
}

/deep/ .project .el-input__inner {
  width: 450px;
}

/deep/ .name .el-input__inner {
  width: 383px;
}

/deep/ .explain {
  .el-textarea {
    width: 590px;
  }
}

/deep/ .user {
  display: flex;

  .el-input__inner {
    width: 220px;
  }

  .el-input__prefix {
    left: -39px;
  }
}

.tableAdd {
  margin: 0 auto;
}

.operation {
  display: flex;
  justify-content: space-around;
  font-size: 12px;

  div {
    padding: 5px 10px;
    border: 1px solid gainsboro;
    cursor: pointer;
  }

  .addShop {
    background-color: rgb(240, 131, 40);
    color: #fff;
  }
}

.commoditList {
  display: flex;
  font-size: 14px;
  cursor: pointer;

  .shop {
    width: 130px;
    text-align: right;
    padding: 0 12px 0 0;
  }

  .import {
    color: rgb(102, 183, 242);
  }

  .importPhoto {
    color: rgb(102, 183, 242);
    margin-left: 36px;
  }
}

.upload {
  .uploadFir {
    span {
      color: rgb(74, 144, 226);
      margin-left: 20px;
    }
  }

  .uploadSec {
    margin-top: 20px;

    span {
      display: inline-block;
      padding: 3px 8px;
      color: #fff;
      background-color: rgb(240, 131, 39);
      border-radius: 5px;
      margin: 0 20px;
    }

    em {
      font-weight: none;
      color: rgb(240, 131, 39);
      font-size: 12px;
    }
  }
}

.continue {
  display: flex;
  background-color: rgb(238, 238, 238);
  padding: 0 0 0 30px;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  div {
    cursor: pointer;
  }
  .continueAdd {
    padding: 5px 10px;
    background: #fff;
  }

  .continueJoin {
    display: flex;
    align-items: center;

    height: 100%;

    .matching {
      color: rgb(131, 177, 230);
      margin-right: 50px;
    }

    .submit {
      height: 100%;
      background: rgb(240, 131, 39);
      line-height: 50px;
      padding: 0 30px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/inquiry/edit.vue